import React, {useState, useEffect} from 'react'
import {
    Pagination,
    PaginationItem,
    PaginationLink,
    Row,
    Col
} from "reactstrap";
const PaginationButtons = ({pageNumber, PageActiveItem, setPageActiveItem}) => {
    const [arrItems, setArrItems] = useState([])
    const [arrItemsLast, setArrItemsLast] = useState(null)

    useEffect(() => {
        const arrItemsBase = Array.from(Array(Math.ceil(pageNumber/50)).keys())
        if (arrItemsBase.length >= 10) {
            const arrItemsBaseLast = arrItemsBase.pop()
            let first = 0
            let last = 10

            if (PageActiveItem >= 6) {
                first = PageActiveItem - 5  
            } 
            
            if (PageActiveItem >= (arrItemsBase.length-5)){
                first = arrItemsBase.length -10
                last = arrItemsBaseLast
            } else if (PageActiveItem >= 6 && (PageActiveItem + 5) < arrItemsBaseLast) {
                last = PageActiveItem + 4 
            } 

            setArrItems(arrItemsBase.slice(first, last))
            setArrItemsLast(arrItemsBaseLast)
        } else {
            setArrItems(arrItemsBase)
        }
    }, [pageNumber, PageActiveItem])

        return(
            <nav  aria-label="...">
                <Pagination style={{justifyContent: 'center'}}>
                    <PaginationItem>
                        <PaginationLink
                            onClick={(e) => setPageActiveItem((prevState) => {
                                if (prevState === (arrItems[0]+1)) {
                                    return(prevState)
                                } else {
                                    return(prevState -1)
                                }
                            })}
                            tabIndex="-1"
                        >
                            Poprzednia
                        </PaginationLink>
                    </PaginationItem>
                    
                    {arrItems.map((arrItem, i) => {
                        return (
                            <PaginationItem className={PageActiveItem === arrItem + 1 ? "active ":''} key={'pagination-item'+i}>
                                <PaginationLink
                                        onClick={(e) => setPageActiveItem(arrItem + 1)}
                                        className={PageActiveItem === arrItem + 1 ? 'btn-aotmit':''} style={ PageActiveItem === (arrItem + 1) ? {backgroundColor:"#17728d"}:{}}
                                    >
                                        {`${arrItem + 1}`}
                                </PaginationLink>
                            </PaginationItem>
                        )
                    })}
                    {arrItemsLast != null && (
                    <>
                    {PageActiveItem < (arrItemsLast-5) && <p>{' '}...{' '}</p>}
                    <PaginationItem className={PageActiveItem === arrItemsLast + 1 ? "active ":''}>
                        <PaginationLink
                                onClick={(e) => setPageActiveItem(arrItemsLast + 1)}
                                className={PageActiveItem === arrItemsLast + 1 ?'btn-aotmit-gradient':''}
                            >
                                {`${arrItemsLast + 1}`}
                        </PaginationLink>
                    </PaginationItem>
                    </>
                    )}                    
                    
                    <PaginationItem> 
                        <PaginationLink
                            onClick={(e) => setPageActiveItem((prevState) => {
                                if (prevState === arrItems.length) {
                                    return(prevState)
                                } else {
                                    return(prevState + 1)
                                }
                            })}
                        >
                            Następna
                        </PaginationLink>
                    </PaginationItem>
                </Pagination>
            </nav>
        )
    // }

    // return (
    //     <div>
    //         {/* <Col className='text-center' style={{marginBottom:"15px"}} >
    //             <Row className={'row-margin text-center'} > */}
    //                 {paginationBuilder(pageNumber)}
    //             {/* </Row>
    //         </Col> */}
    //     </div>
    // )
}
export default PaginationButtons
